import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationsService } from 'angular2-notifications';
import { QuestionServiceService, FeeColumnFilterPanelService } from '../../../services';
import { take } from '../../../models';

@Component({
  selector: 'app-tryout-custom-questions',
  templateUrl: './tryout-custom-questions.component.html',
  styleUrls: ['./tryout-custom-questions.component.css']
})
export class TryoutCustomQuestionsComponent implements OnInit, OnChanges {
  @Input() TryoutMemberID: number;
  @Input() clubProgramId: any;
  @Output() closeSideOverlayEvent = new EventEmitter();
  @Output() refreshQuestions = new EventEmitter();
  
  public setCustomQuestions: FormGroup;  
  public QuesstionList = [];
  public Answers = [];
  public Option = [];
  public currentUrl = '';
  public validationMessages = {};
  public AnswerID: number;
  public QuestionID: number;
  public AnswersData = [];

  constructor(
    private fb: FormBuilder,
    private spinnerService: Ng4LoadingSpinnerService,
    private notificationsService: NotificationsService,
    private questionService: QuestionServiceService,
  ) {
    this.validationMessages = {
      'FirstName': 'First Name is required.',
      'LastName': 'Last Name is required.',
      'Gender': 'Gender is required.',
      'PlayerEmail': 'Player Email is required.',
      'PlayerPhone': 'Player Phone is required.',
      'Address': 'Address is required.',
      'City': 'City is required.',
      'State': 'State is required.',
      'PostalCode': 'Postal Code is required.',
      'Citizenship': 'Citizenship is required.',
      'ParentGuardian': 'Parent/Guardian is required.',
      'CellPhone': 'Cell Phone is required.',
      'ParentEmail': 'Parent Email is required.',
    };
  }

  ngOnInit() {
    this.getQuestions('0');
    this.initSetQuestionForm();
    this.clearValidation();
    this.initSetQuestionForm();
  }

  ngOnChanges(data) {
    if (data.TryoutMemberID) {
      this.getQuestions('0');
    }
  }

  initSetQuestionForm() {
    const groups = {
    };
    if (!!this.QuesstionList && !!this.QuesstionList.length) {
      const len = this.QuesstionList.length;
      for (let i = 0; i < len; i++) {
        const item = this.QuesstionList[i];

        const selectedOption = item.queOptionList && item.queOptionList.length
          && item.queOptionList.find(x => x.isSelected);

        if (!item) { continue; }
        groups[item.label] = [selectedOption ? selectedOption.clubProgramQuestionOptionID : item.answer, [Validators.required]];

      }
    }

    this.setCustomQuestions = this.fb.group(groups);
  }


  getQuestions(status) {

    this.spinnerService.show();
    const UserID = this.TryoutMemberID.toString();
    this.questionService.getSetQuestions(this.clubProgramId, status, UserID).pipe(take(1)).subscribe(rs => {
      if (rs && rs.customQuestionAnswerList != null) {
        this.QuesstionList = rs.customQuestionAnswerList;
      } else {
        this.QuesstionList = [];
      }
      this.initSetQuestionForm();
      this.spinnerService.hide();
    });
  }


  clearValidation() {
    for (let i = 0; i < this.QuesstionList.length; i++) {
      if (this.QuesstionList[i].questionTypeID !== 1) {
        this.removeValidaionCodeDiscount(this.QuesstionList[i].name);
      } else if (this.QuesstionList[i].questionTypeID !== 2) {
        this.removeValidaionCodeDiscount(this.QuesstionList[i].name);
      } else if (this.QuesstionList[i].questionTypeID !== 3) {
        this.removeValidaionCodeDiscount(this.QuesstionList[i].name);
      } else if (this.QuesstionList[i].questionTypeID !== 4) {
        this.removeValidaionCodeDiscount(this.QuesstionList[i].name);
      } else if (this.QuesstionList[i].questionTypeID !== 5) {
        this.removeValidaionCodeDiscount(this.QuesstionList[i].name);
      }
    }
  }

  removeValidaionCodeDiscount(name) {
    const control = this.setCustomQuestions.get(name);
    if (control) {
      control.clearValidators();
      control.updateValueAndValidity();
    }
  }

  validateUi() {
    Object.keys(this.setCustomQuestions.controls).forEach(field => {
      const control = this.setCustomQuestions.get(field);
      if (control)
        control.markAsTouched({ onlySelf: true });
    });
  }

  public validOptionAnswers = [];
  onCheckBoxChange(event, id, des, qId) {
    if (event.target.checked) {
      const OpionData = {
        questionId: qId,
        clubProgramAnswerID: Number(id),
        description: des.toString()
      };
      this.Option.push(OpionData);
    } else {
      //const index = this.Option.indexOf(Number(id));
      for (let i = 0; i < this.Option.length; i++) {
        if (this.Option[i].questionId == qId && this.Option[i].clubProgramAnswerID == Number(id)) {
          this.Option.splice(i, 1);
          break;
        }
      }
    }

    //console.log("this.Option =>", this.Option);
    for (let i = 0; i < this.QuesstionList.length; i++) {
      if (this.QuesstionList[i].questiontype == "Multiple Choice" && this.QuesstionList[i].isrequired == 1 && this.QuesstionList[i].clubprogramquestionID == qId) {
        var foundOption = false;
        this.Option.forEach(x => {
          if (x.questionId == this.QuesstionList[i].clubprogramquestionID) {
            this.setCustomQuestions.controls[this.QuesstionList[i].label].setValue(Number(id));
            this.setCustomQuestions.get(this.QuesstionList[i].label).setErrors(null);
            foundOption = true;
          }
        });
        if (!foundOption)
          this.setCustomQuestions.get(this.QuesstionList[i].label).setErrors({ 'required': true });

        //console.log("foundOption =>", this.QuesstionList[i].clubprogramquestionID, foundOption);
      }
    }
  }

  get isValid(): boolean {
    // console.log(this.questionForm.controls);
    if (this.setCustomQuestions.invalid) {
      // console.log("false");
      return false;
    }
    else {

    }
    // console.log("true");
    return true;
  }

  onSave(event, status) {
    event.stopPropagation();
    this.validateUi();
    const data = this.QuesstionList.map(q => {
      q.answer = this.setCustomQuestions.controls[q.label].value;
    });

    //console.log("status =>", status);
    //console.log("setCustomQuestions =>", this.setCustomQuestions);

    if (status === 'VALID') {
      event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      this.questionService.updateUserCustomAnswers(this.QuesstionList).subscribe(rs => {
        event.target.innerHTML = 'Save';
        event.target.disabled = false;
        console.log('result', rs);
        this.alertMessage('success', rs);
        this.refreshQuestions.emit();
        this.closeSideOverlayEvent.emit();

      }, error => {
        console.log("error =>", error);
        event.target.innerHTML = 'Save';
        event.target.disabled = false;
        this.alertMessage('error', error.error);
      });

    }


    //const data = this.QuesstionList.map(q => {
    //  let selectedOption;
    //  let answer;
    //  let answerOptionList = [];
    //  let answerID = 0;
    //  if (q.clubprogramquestiontypeID === 1) {
    //    answerOptionList = q.queOptionList.filter(o => o.isSelected).map(o => ({
    //      clubProgramAnswerID: o.clubProgramQuestionOptionID,
    //      description: o.optionDescription
    //    }));
    //    answer = answerOptionList.map(o => o.description).join(',');
    //  } else if (q.queOptionList && q.queOptionList.length) {
    //    selectedOption = q.queOptionList.find(x => x.clubProgramQuestionOptionID === +this.setCustomQuestions.controls[q.label].value);
    //    answer = selectedOption ? selectedOption.optionDescription : this.setCustomQuestions.controls[q.label].value;
    //    answerID = selectedOption ? selectedOption.clubProgramQuestionOptionID : 0;
    //  } else {
    //    answer = this.setCustomQuestions.controls[q.label].value;
    //    answerID = q.clubprogramanswerID;
    //  }

    //  return {
    //    UserID: +this.TryoutMemberID,
    //    Answer: answer,
    //    Question: q.label,
    //    ClubProgramAnswerID: answerID,
    //    ClubProgramQuestionID: q.clubprogramquestionID,
    //    AnswerOptionList: answerOptionList
    //  };
    //});

    //if (status === 'VALID') {
    //  const OBJ = {
    //    answers: data
    //  };

    //  event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
    //  event.target.disabled = true;
    //  this.questionService.updateAnswer(OBJ).subscribe(rs => {
    //    event.target.innerHTML = 'Save';
    //    event.target.disabled = false;
    //    console.log('result', rs);
    //    this.alertMessage('success', rs);
    //    this.closeSideOverlayEvent.emit();

    //  }, error => {
    //    this.alertMessage('error', error.statusText);
    //  });
    //}
  }
  onCancle(event) {
    this.clearFormData();
    this.closeSideOverlayEvent.emit();
    this.setCustomQuestions.reset();
    this.setCustomQuestions.clearValidators();
    this.setCustomQuestions.updateValueAndValidity();
  }

  clearFormData() {
    this.setCustomQuestions.reset();
    //const t = this.questionType;
    //if (t === 1 || t === 2 || t === 3) {
    //  if (typeof this.OptionArray !== 'undefined') {
    //    this.clearFormArray(this.OptionArray);
    //  }
    //}
  }

  isValidIsMultiChoice(required, name) {
    if (required === 1) {
      return this.setCustomQuestions.get(name).errors
        && (this.setCustomQuestions.get(name).touched
          || this.setCustomQuestions.get(name).dirty);
    }
  }

  isValidSingleChoice(required, name) {
    if (required === 1) {
      return this.setCustomQuestions.get(name).errors
        && (this.setCustomQuestions.get(name).touched
          || this.setCustomQuestions.get(name).dirty);
    }
  }

  isValidDropDown(required, name) {
    if (required === 1) {
      return this.setCustomQuestions.get(name).errors
        && (this.setCustomQuestions.get(name).touched
          || this.setCustomQuestions.get(name).dirty);
    }
  }

  isValidIsSingleLine(required, name) {

    if (required === 1) {
      return this.setCustomQuestions.get(name).errors
        && (this.setCustomQuestions.get(name).touched
          || this.setCustomQuestions.get(name).dirty);
    }
  }

  isValidLongText(required, name) {
    if (required === 1) {
      return this.setCustomQuestions.get(name).errors
        && (this.setCustomQuestions.get(name).touched
          || this.setCustomQuestions.get(name).dirty);
    }
  }

  alertMessage(status, message) {
    const toast = this.notificationsService.success(status, message, {
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: false
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tryout-custom-questions/tryout-custom-questions.component.ts